import { propOr } from 'ramda';

export const getEnvironment = propOr({}, 'environment');
